import React from 'react'
import assets from 'xui/assets'
import CommonLogo, { ICommonLogoOptionalProps } from './CommonLogo'

// const LOGO = require('../img/packge_tag/bronze.png')
const LOGO = assets.images.packgeTag.bronze


const BronzePackageTag = (props: ICommonLogoOptionalProps) => <CommonLogo source={LOGO} {...props} />

export default BronzePackageTag
